import type { ClassValue } from 'clsx';
import { useTranslation } from 'react-i18next';

import { VCircleProgressBar, VFlex, VStack, new__cn as cn } from '@/package';

const LoadingIndicator = ({
  className,
  message = 'Loading...',
}: {
  className?: ClassValue;
  message?: string;
}) => {
  const { t } = useTranslation();

  return (
    <VFlex
      className={cn(
        'fixed top-0 left-0 z-9999 h-screen w-screen bg-black/50',
        className,
      )}
      items="center"
      justify="center"
    >
      <VStack
        className="w-90 rounded-md bg-white/90 px-6 py-8 shadow-sm @md:w-104"
        justify="center"
        items="center"
        gap={1}
      >
        <VCircleProgressBar className="animate-spin" size="small" value={30} />
        <VStack gap={0.5} items="center">
          <div>{message}</div>
          <div className="text-body-md">
            {t('common.loadingIndicatorWaitingMessage.gastrostege')}
          </div>
        </VStack>
      </VStack>
    </VFlex>
  );
};

export default LoadingIndicator;
